module.exports = __webpack_public_path__ + "img/email.8c195fb0.svg";